var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 12.8996C8.90131 12.9001 8.80347 12.8812 8.71209 12.8439C8.62071 12.8066 8.5376 12.7516 8.46752 12.6821L3.96752 8.18205C3.89759 8.11212 3.84212 8.02911 3.80427 7.93774C3.76643 7.84637 3.74695 7.74845 3.74695 7.64955C3.74695 7.44983 3.82629 7.25828 3.96752 7.11705C4.10874 6.97583 4.30029 6.89648 4.50002 6.89648C4.69974 6.89648 4.89129 6.97583 5.03252 7.11705L9.00002 11.0846L12.9675 7.11705C13.0374 7.04712 13.1205 6.99165 13.2118 6.95381C13.3032 6.91596 13.4011 6.89648 13.5 6.89648C13.5989 6.89648 13.6968 6.91596 13.7882 6.95381C13.8796 6.99165 13.9626 7.04712 14.0325 7.11705C14.1024 7.18698 14.1579 7.27 14.1958 7.36137C14.2336 7.45273 14.2531 7.55066 14.2531 7.64955C14.2531 7.74845 14.2336 7.84637 14.1958 7.93774C14.1579 8.02911 14.1024 8.11212 14.0325 8.18205L9.53252 12.6821C9.46244 12.7516 9.37932 12.8066 9.28795 12.8439C9.19657 12.8812 9.09872 12.9001 9.00002 12.8996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskArrow);
export default __webpack_public_path__ + "static/media/task-arrow.5809b55362007a0ef3f126087ea3dbb7.svg";
export { ForwardRef as ReactComponent };